export type Role = 'ADMIN' | 'MANAGER' | 'DRIVER'
export type NavigationProvider = 'google' | 'waze'

export type GeoPoint = {
  latitude: number
  longitude: number
}

export type RoutableOrder = GeoPoint & {
  id: string
  city: string
  neighborhood: string
  addressNormalized?: string
  priority?: number
}

export type PlannedStop = RoutableOrder & {
  sequence: number
  distanceFromPreviousKm: number
}

export type PlannedRoute = {
  driverIndex: number
  stops: PlannedStop[]
  distanceKm: number
}

export const STICKER_HEADERS = [
  'Recebido em',
  'Enviado em',
  'Origem',
  'Página',
  'Nome',
  'WhatsApp',
  'CEP',
  'Logradouro',
  'Número',
  'Complemento',
  'Bairro',
  'Cidade',
  'Estado',
  'Ponto de referência',
  'Quantidade',
  'Consentimento',
  'Status',
  'UTM origem',
  'UTM mídia',
  'UTM campanha',
  'JSON técnico',
  'ID externo',
  'Modelo escolhido',
] as const

export type ImportedStickerRow = {
  sourceRowNumber: number
  receivedAt?: string
  source?: string
  page?: string
  recipientName: string
  phone: string
  cep: string
  street: string
  streetNumber: string
  complement?: string
  neighborhood: string
  city: string
  state: string
  referencePoint?: string
  quantity: number
  consent: boolean
  status?: string
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
  externalId?: string
  stickerModels: string[]
  /** Endereço livre de planilha legada; entra na base, mas exige conferência operacional. */
  needsAddressReview?: boolean
}

export type DuplicateDecision =
  | { kind: 'NEW' }
  | { kind: 'MERGE_EXACT'; existingOrderId: string }
  | { kind: 'REVIEW_PHONE'; existingOrderId: string }
  | { kind: 'REVIEW_ADDRESS'; existingOrderId: string }

export type ExistingOrderFingerprint = {
  id: string
  phoneNormalized: string
  addressNormalized: string
  exactDuplicateKey: string
}
